module.exports = __webpack_public_path__ + "static/media/HouseSmartTextLogo.7556ab46.svg";